document.addEventListener('turbolinks:load', () => {
  $('#uis-delete-button').click(function() {

    $.getJSON('/uni_systems/cis_list', {"uis_ids[]": getUisIds()}).done(function(data) {

      try {
        if (!data || typeof data !== 'object') {
          throw new Error('<8k4o71m2> Received data is not correct');
        }

        let confirmation_message = getConfirmationMessage(data);
        let answer = data.length > 0 ? confirm(confirmation_message) : alert('Не выбрано ни одной ЕИС!');

        if (answer) {
          $.get('/uni_systems/bulk_destroy', { "uis_ids[]": getUisIds() }).done(function() {
            location.reload()
          })
        }
      }
      catch (error) {
        console.error(error.message);
      }
    }).fail(function(xhr, status, error) {
        console.error('<5h7j62v7> ', error);
    });
  })

  $('#uis-card-show-signer-params').click(function() {
    if( $('#signer-parameters-is-shown').val() == 'false' ) {
      $('#signer-parameters').slideDown(1000);
      $('#signer-parameters-is-shown').val('true');
      $('#uis-card-show-signer-params').text('Скрыть параметры подключения к Signer');
    }
    else {
      $('#signer-parameters').slideUp(1000);
      $('#signer-parameters-is-shown').val('false');
      $('#uis-card-show-signer-params').text('Показать параметры подключения к Signer');
    }
  })

  $('.uis-delete-checkbox').change(function() {
    let ids = getUisIds()
    if (ids.length > 0) {
      $('#uis-delete-button').removeClass('disabled')
    } else {
      $('#uis-delete-button').addClass('disabled')
    }
  })

  function getConfirmationMessage(data) {
    const uni_ids = [...new Set(data.map(uni => uni.id))];

    let confirmation_message = 'ВНИМАНИЕ!';
    for (const id of uni_ids) {
      let ci_systems = data.filter(uni_sys => uni_sys.id === id);
      confirmation_message += `\nПри удалении ЕИС ${ci_systems[0].uni_name} будут удалены связанные КИС:\n`;
      confirmation_message += ci_systems.map(ci => ci.ci_name).join('\n');
    }
    confirmation_message += '\nУдалить выбранные ЕИС?';

    return confirmation_message;
  }

  function getUisIds() {
    const uis_ids = []
    $('.uis-delete-checkbox:checked').each(function() {
      uis_ids.push(this.value)
    })
    return uis_ids
  }

  $('#crypto-mode-select').change(function() {
    if ($('#crypto-mode-select').val() === "remote") {
      $('#signer-parameters-remote').slideDown(1000);
      $('#signer-parameters-local').slideUp(1000);
    } else {
      $('#signer-parameters-remote').slideUp(1000);
      $('#signer-parameters-local').slideDown(1000);
    }
  })

  $('#uni_system_validate_esia_answer').change(function() {
    if ($('#uni_system_validate_esia_answer').is(':checked')) {
      $('#signer-esia-certificates').slideDown(100);
    } else {
      $('#signer-esia-certificates').slideUp(100);
    }
  })
})
